export const sendEmail = {
    uk: {
        heading: "Відправити повідомлення",
        name: "Ім'я",
        email: "Електронна адреса",
        phone: "Телефон (необовʼязково)",
        message: "Повідомлення",
        messageFillout: "Будь ласка, заповніть форму",
        messageEmailsent: "Ваше повідомлення успішно надіслано. Ми зв’яжемося з вами найближчим часом",
        messageHoldon: "Зачекайте, будь ласка…",
    },
    en: {
        heading: "Send a message",
        name: "Name",
        email: "Email",
        phone: "Phone (optional)",
        message: "Message",
        messageFillout: "Please, fill out the form",
        messageEmailsent: "Your email has been sent successfully. We’ll get back to you shortly",
        messageHoldon: "Hold on a moment, please...",
    }
}